import { render, staticRenderFns } from "./StickyPanel.vue?vue&type=template&id=2a0c9f4d"
import script from "./StickyPanel.vue?vue&type=script&lang=js"
export * from "./StickyPanel.vue?vue&type=script&lang=js"
import style0 from "./StickyPanel.vue?vue&type=style&index=0&id=2a0c9f4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports